<template>
  <div class="intheexam">
    <div v-if="Data && !isEnd">
      <h3>信用修复培训考试·修复项《{{Data.lxName}}》</h3>
      <p>考生姓名：{{Data.pxrXm}}  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;身份证：{{Data.pxrSfz}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;限时：60分钟<em v-if="timerStr">剩余时间：<span>{{timerStr}}</span></em></p>
      <div class="solid">
        <img style="display: block;width: 100%;margin-top: 10px;" src="/static/images/new/ks_top.png" alt="">
      </div>
      <div class="exam_list">
        <div class="exam_li" v-for="(item,index) in Data.ksNr" :key="index">
          <div class="exam_li_tm">{{index + 1}}. {{item.ktTm}} </div>
          <div v-if="item.ktTx == 0">
            <el-radio v-model="item.ktDa" label="A">A. {{item.ktXx1}}</el-radio>
            <el-radio v-model="item.ktDa" label="B">B. {{item.ktXx2}}</el-radio>
            <el-radio v-model="item.ktDa" label="C">C. {{item.ktXx3}}</el-radio>
            <el-radio v-model="item.ktDa" label="D">D. {{item.ktXx4}}</el-radio>
          </div>
          <div v-else>
            <el-checkbox v-model="item.ktDa" label="A">A. {{item.ktXx1}}</el-checkbox>
            <el-checkbox v-model="item.ktDa" label="B">B. {{item.ktXx2}}</el-checkbox>
            <el-checkbox v-model="item.ktDa" label="C">C. {{item.ktXx3}}</el-checkbox>
            <el-checkbox v-model="item.ktDa" label="D">
              <div class="da">D. {{item.ktXx4}}</div>
            </el-checkbox>
          </div>
        </div>
      </div>
      <div v-if="Data.syMs <= 0 || isEndAxam" class="submit_btn"
           @click="submitBtn()">提交</div>
      <div v-else class="submit_btn cant">提交</div>
    </div>
    <div v-else class="status">
      <div v-if="cj">
        <!-- <h3>本次考试得分</h3> -->
		<div v-if="cj.ksCj >= 85">
			<img src="/static/images/new/icon_dz.png" alt="">
		</div>
		<div v-else>
			<img src="/static/images/new/img_del.png" alt="">
		</div>
		<div v-if="cj.ksCj >= 85" style="color: #202331;font-size: 20px;font-weight: 500;margin-top: 15px;">恭喜您，已通过考试</div>
		<div v-else style="color: #202331;font-size: 20px;font-weight: 500;margin-top: 15px;">对不起,考试未通过！</div>
		<div style="font-size: 16px;color: #777C94;margin-top: 20px;">已完成学时课程</div>
		<div v-if="cj.ksCj >= 85"	 style="color: #2287FF;font-size: 16px;margin-top: 40px;">请点“申请报告”提交材料后等待审核</div>
        <!-- <h4>{{_self.cj.ksCj}}</h4> -->
        <!-- <router-link  tag="div" :to="{path: '/center',query:{lxId:lxId}}" class="back">返回学习中心</router-link> -->
        <!-- <a href="/center" class="back">返回学习中心</a> -->
		<div  class="return_idx" @click="hangleReturn">返回首页</div>
		<div class="add_ks" v-if="cj.ksCj < 85" @click="isEnd = false,getData()">再次参加考试</div>
		<div v-if="cj.ksCj >= 85" class="back" @click="downs(6)">查看培训证明</div>
		<div class="join" @click="dialogVisible = true">查看成绩单</div>
    <div v-if="cj.ksCj >= 85" class="apply" @click="apply()">申请报告</div>
      </div>

    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      top="5vh"
      width="1000px">
      <cjd :cj="cj"></cjd>
    </el-dialog>
  </div>
</template>

<script>
	import { cookie } from "@/common/js/cookies.js";
import cjd from "@/components/exam/cjd";
export default {
  name: "intheexam",
  props:['lxId'],
  data() {
    return {
      Data: null,
      timer: null,
      isEnd: false,
      cj: null,
      dialogVisible: false,
      qyId: null,
      timerStr: null,
    };
  },
  computed: {
    isEndAxam() {
      let end = true;
      let _self = this;
      for (let i in _self.Data.ksNr[i]) {
        if (
          _self.Data.ksNr[i].ktDa == "" ||
          _self.Data.ksNr[i].ktDa.length == 0 ||
          _self.Data.ksNr[i].ktDa == null
        ) {
          end = false;
        }
      }
      return end;
    }
  },
  mounted() {
    this.getData();
	this.getData1()
  },
  methods: {
	  // 返回首页
	  hangleReturn(){
		this.$router.push('/')
	  },
    //转换时间
    secondToDate(result) {
      var m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
      var s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));
      return result = m + ":" + s;
    },
		//获取成绩单
		getData1: function () {
		  let _self = this;
		  let ajax = _self.$http.create();
		  let data = {
        lxId:this.lxId
      };
		  const loading = this.$loading({
			lock: true,
			text: 'Loading',
			spinner: 'el-icon-loading',
			background: 'rgba(0, 0, 0, 0.7)'
		  });
		  ajax({
			method: 'post',
			url: SOWINURL + 'XxKh/getEnterpriseCenter',
			data: data,
			headers:{
				'token': cookie.get("xyxf_token_qt")
			}
		  }).then(function (json) {
			if (json.data.result == 1) {
			  _self.Data1 = json.data.data;
			  _self.qyId = json.data.data.qyId;
			} else {
			  _self.$message({
				showClose: true,
				message: json.data.errorcode,
				type: 'error'
			  });
			}
			loading.close();

		  }).catch(function (error) {
			loading.close();
			console.log(error);
		  });
		},
    apply() {
      this.$router.push({
        path: "/qyrz",
        query: {
          qyId: this.cj.qyId,
          lxCjbg: this.cj.lxCjbg,
          qyActive: 0,
          isApplyFor: 1, //区分是申请报告还是关联外省企业
          pxlx: this.cj.lxId,
        },
      });
    },
		//预览培训证明
		downs(type){
		  let _self = this;
		  let ajax = _self.$http.create();
			const loading = this.$loading({
			  lock: true,
			  text: 'Loading',
			  spinner: 'el-icon-loading',
			  background: 'rgba(0, 0, 0, 0.7)'
			});
		  ajax({
			method: "post",
			url: SOWINURL + "report/getQyfj",
			data:{
				qyId: _self.qyId,
				fjType: type
			},
			headers:{
				'token': cookie.get("xyxf_token_qt")
			}
		  })
		  .then(function(json) {
			  _self.download(json.data.data)
			  loading.close();
		  })
		  .catch(function(error) {
				loading.close();
			console.log(error);
		  })
		},
		download (data) {
		        if (!data) {
		            return
		        }
		        let url = data;
		        let link = document.createElement('a')
		        link.style.display = 'none'
		        link.href = url
		        link.setAttribute('download', '')
				link.setAttribute('target', '_blank')

		        document.body.appendChild(link)
		        link.click()
		},
    getData: function() {
      let _self = this;
      let ajax = _self.$http.create();
      let data = {
        lxId:this.lxId
      };
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      ajax({
        method: "post",
        url: SOWINURL + "XxKh/GeneratTestPapers",
        data: data,
			headers:{
				'token': cookie.get("xyxf_token_qt")
			}
      })
        .then(function(json) {
          if (json.data.result == 1) {
            _self.Data = json.data.data;
            for (let i in _self.Data.ksNr) {
              if (_self.Data.ksNr[i].ktTx == 1) {
                _self.Data.ksNr[i].ktDa = [];
              }
            }
            if (_self.Data.syMs > 0) {
              _self.timer = setInterval(function() {
                if (_self.Data.syMs > 0) {
                  _self.Data.syMs--;
                } else {
                  _self.$message({
                    showClose: true,
                    message: "剩余考试时间为00:00，将自动提交试卷！",
                    type: "error"
                  });

                  clearInterval(_self.timer);
                  setTimeout(function(){
                    _self.submitBtn();
                  },1500)
                }

                _self.timerStr = _self.secondToDate(_self.Data.syMs);
              }, 1000);
            } else {
              _self.$message({
                showClose: true,
                message: "剩余考试时间为00:00，将自动提交试卷！",
                type: "error"
              });
              setTimeout(function(){
                _self.submitBtn();
              },1500)
            }
          } else {
            _self.$message({
              showClose: true,
              message: json.data.errorcode,
              type: "error"
            });
          }
          loading.close();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    submitBtn: function() {
      let _self = this;
      let ajax = _self.$http.create();
      for (let i in _self.Data.ksNr) {
        let arr = "";
        for (let j in _self.Data.ksNr[i].ktDa) {
          if (j < _self.Data.ksNr[i].ktDa.length - 1) {
            arr += _self.Data.ksNr[i].ktDa[j] + ",";
          } else {
            arr += _self.Data.ksNr[i].ktDa[j] + "";
          }
        }
        _self.Data.ksNr[i].ktDa = arr;
      }

      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      ajax({
        method: "post",
        url: SOWINURL + "/XxKh/SubmitPapers",
        data: {
          ksId: _self.Data.ksId,
          ksTjda: _self.Data.ksNr
        },
			headers:{
				'token': cookie.get("xyxf_token_qt")
			}
      })
        .then(function(json) {
          if (json.data.result == 1) {
            _self.cj = json.data.data;
            _self.isEnd = true;
            _self.$message({
              showClose: true,
              message: "提交成功！",
              type: "success"
            });
            // 回到顶部
            document.body.scrollTop = document.documentElement.scrollTop = 0;
          } else {
            _self.$message({
              showClose: true,
              message: json.data.errorcode,
              type: "error"
            });
          }
          loading.close();
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  },
  components: {
    cjd
  },
  beforeDestroy() {
    let _self = this;
    clearInterval(_self.timer);
  }
};
</script>

<style scoped lang="less" type="text/less">
.el-radio__label{
  width: 975px;
  display: inline-block;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: normal;
  margin-left: 10px;
  // margin-top: 20px;
}
.el-radio__inner{
  margin-bottom: 20px;
}

.intheexam {
  .status {
    text-align: center;
    padding: 130px 0 200px 0;
    h3 {
      height: 50px;
      line-height: 50px;
      text-align: center;
      color: #06103b;
      font-size: 30px;
    }
    h4 {
      height: 100px;
      line-height: 100px;
      text-align: center;
      font-size: 80px;
      color: #06103b;
      margin-bottom: 100px;
    }
	.return_idx{
		width: 210px;
		height: 45px;
		border-radius: 8px;
		border: 1px solid rgba(0, 134, 255, 0.69);
		color: #2287FF;
		text-align: center;
		line-height: 45px;
		display: inline-block;
		margin-right: 10px;
		cursor: pointer;
		margin-top: 100px;
	}
   .back {
   	width: 210px;
   	height: 45px;
   	border-radius: 8px;
   	// border: 1px solid rgba(0, 134, 255, 0.69);
	background: #2287FF;
   	text-align: center;
   	color: #fff;
   	line-height: 45px;
   	display: inline-block;
   	margin-right: 10px;
	cursor: pointer;
	margin-top: 100px;
   }
   .apply {
   	width: 210px;
   	height: 45px;
   	border-radius: 8px;
   	// border: 1px solid rgba(0, 134, 255, 0.69);
    background: #F49228;
   	text-align: center;
   	color: #fff;
   	line-height: 45px;
   	display: inline-block;
   	margin-left: 10px;
	cursor: pointer;
	margin-top: 100px;
   }
   .join {
     width: 210px;
     height: 45px;
     background: #75D087;
     border-radius: 8px;
     color: #fff;
     line-height: 45px;
     text-align: center;
     display: inline-block;
	 cursor: pointer;
	 margin-top: 100px;
   }
   .add_ks{
	   width: 210px;
	   height: 45px;
	   background: #2287FF;
	   border-radius: 8px;
	   text-align: center;
	   line-height: 45px;
	   color: #fff;
	   margin-right: 10px;
	   display: inline-block;
	   cursor: pointer;
   }
  }
  h3 {
    height: 60px;
    line-height: 60px;
    text-align: center;
    font-size: 24px;
    color: #06103b;
    margin-bottom: 20px;
  }
  .solid {
    // border-bottom: 1px solid #1b1b1b;
	margin: 10px;
    margin-bottom: 32px;
  }
  .submit_btn {
    width: 158px;
    height: 48px;
    line-height: 48px;
    margin: 0 auto;
    text-align: center;
    font-size: 22px;
    cursor: pointer;
    background: -webkit-linear-gradient(
      left,
      #0076ff,
      #00c9ff
    ); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(
      right,
      #0076ff,
      #00c9ff
    ); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(
      right,
      #0076ff,
      #00c9ff
    ); /* Firefox 3.6 - 15 */
    background: linear-gradient(to right, #0076ff, #00c9ff); /* 标准的语法 */
    color: #fff;
    border-radius: 24px;
  }
  .cant {
    color: #fff;
    background: #e5e5e5;
  }
  .exam_list {
    padding-bottom: 100px;
    .exam_li_tm {
      line-height: 30px;
      font-size: 16px;
      color: #06103b;
      margin-bottom: 20px;
    }
    .exam_li {
      margin-bottom: 80px;
    }
    .el-radio,
    .el-checkbox {
      display: block;
      line-height: 30px;
      height: auto;
      width: 1010px;
      font-size: 16px;
      color: #06103b;
      clear: both;
      .da {
        line-height: 20px;
        white-space: normal;
        display: initial;
      }
    }
  }
  p {
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    color: #06103b;
    // border-bottom: 1px solid #1b1b1b;
    em {
      float: right;
      height: 40px;
      line-height: 40px;
      display: block;
      font-style: normal;
      span {
        color: #0076ff;
      }
    }
  }
}
.intheexam .exam_list .el-radio__input{
	position: absolute;
	top: 9px;
	left: -5px;
}
.intheexam .exam_list .el-checkbox__input{
	position: absolute;
	top: 9px;
	left: -10px;
}
.intheexam .exam_list .el-checkbox__label{
	width: 978px;
	line-height: 30px;
	margin-bottom: 10px;
}
.intheexam  .el-checkbox, .intheexam  .el-checkbox__input,.intheexam  .el-radio, .intheexam  .el-radio__label{
	white-space: normal;
}
// .intheexam .el-radio__inner{
// 	position: absolute;
// 	top: 0;
// 	left: 0;
// }
</style>
<style scoped>
  >>>.el-checkbox__label{
    display: initial;
  }
</style>



// WEBPACK FOOTER //
// src/components/exam/intheexam.vue